/* eslint-disable*/
import VueStoreService from './VueStoreService';
const AutoPartsService = {

    async getAutoParts(filter,store){
        var resp = await VueStoreService.get("autopart"+filter, store)
        return resp;
    },
    async getAutoPartById(autopart_id,store){
        var resp = await VueStoreService.get("autopart/"+autopart_id, store)
        return resp;
    },
    async saveAutoPart(data,store){
        var resp = await VueStoreService.post("autopart",data,store)
        return resp;
    },
    async updateAutoPart(autopart_id,data,store){
        var resp = await VueStoreService.patch("autopart/"+autopart_id,data,store)
        return resp;
    },
    async deleteAutoPart(autopart_id,store){
        var resp = await VueStoreService.delete("autopart/"+autopart_id,store)
        return resp;
    },

    //MARCAS
    async getAutoPartsBrand(filter,store){
        var resp = await VueStoreService.get("autopart-brand"+filter, store)
        return resp;
    },
    async saveAutoPartBrand(data,store){
        var resp = await VueStoreService.post("autopart-brand",data,store)
        return resp;
    },
    async getAutoPartBrand(autopartbrand_id,store){
        var resp = await VueStoreService.get( "autopart-brand/"+autopartbrand_id,store)
        return resp;
    },
    async updateAutoPartBrand(autopartbrand_id,data,store){
        var resp = await VueStoreService.patch("autopart-brand/"+autopartbrand_id,data,store)
        return resp;
    },

    async deleteAutoPartBrand(autopartbrand_id,store){
        var resp = await VueStoreService.delete("autopart-brand/"+autopartbrand_id,store)
        return resp;
    },

    //CATEGORIA
    async getAutoPartsCategory(filter,store){
        var resp = await VueStoreService.get("autopart-category"+filter, store)
        return resp;
    },
    async saveAutoPartCategory(data,store){
        var resp = await VueStoreService.post("autopart-category",data,store)
        return resp;
    },
    async getAutoPartCategory(autopartcat_id,store){
        var resp = await VueStoreService.get( "autopart-category/"+autopartcat_id,store)
        return resp;
    },
    async updateAutoPartCategory(autopartcat_id,data,store){
        var resp = await VueStoreService.patch("autopart-category/"+autopartcat_id,data,store)
        return resp;
    },

    async deleteAutoPartCategory(autopartcat_id,store){
        var resp = await VueStoreService.delete("autopart-category/"+autopartcat_id,store)
        return resp;
    },
}

export default AutoPartsService;